//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
	data(){
		return{
			
		}
	},
	methods:{
		getRange(){
			return this.$store.dispatch("getRange");
		}
	},
	mounted(){
		this.getRange();
		this.$store.dispatch('setIndex',1);
	},
	computed:{
		list(){
			if(this.$store.getters.getRange){
				var str = this.$store.getters.getRange.rank.list;
				for(var i = 0; i<str.length; i++){
					str[i].banner7url =  str[i].banner7url.replace(/{size}/g,'400');
					str[i].bannerurl =  str[i].bannerurl.replace(/{size}/g,'400');
					str[i].imgurl =  str[i].imgurl.replace(/{size}/g,'400');
				}
				for(var i = 0;i<str.length;i++){
					if(str[i].rankname.slice(0,2) == '酷狗' ){
						str[i].rankname = '爱乐'+str[i].rankname.slice(2,);
					}
				}
				return 	str;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/r_content.vue